import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PartyPopper, ArrowRight, Unlock } from 'lucide-react';

const DOTS = ['#922A8C', '#4c124a', '#14A3A3', '#F2B705', '#922A8C', '#14A3A3', '#F2B705', '#4c124a', '#922A8C', '#14A3A3', '#F2B705', '#922A8C'];

export const OrientationCelebration = ({ course, onClose }) => {
  const navigate = useNavigate();
  const go = () => {
    onClose();
    navigate(course?.next_lesson_id ? `/helpconnect/courses/${course.id}/lessons/${course.next_lesson_id}` : course ? `/helpconnect/courses/${course.id}` : '/helpconnect/courses');
  };
  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-4" role="dialog" aria-modal="true" data-testid="hc-orientation-celebration">
      <div className="absolute inset-0 bg-[#4c124a]/60 backdrop-blur-sm" onClick={onClose} />
      <div className="relative w-full max-w-md bg-white rounded-3xl p-8 text-center shadow-2xl overflow-hidden hc-pop">
        {DOTS.map((c, i) => (
          <span key={i} className="hc-confetti" style={{ background: c, left: `${6 + i * 8}%`, animationDelay: `${(i % 6) * 0.12}s` }} />
        ))}
        <div className="mx-auto w-20 h-20 rounded-full bg-[#F6EAF5] flex items-center justify-center">
          <PartyPopper className="w-10 h-10 text-[#922A8C]" />
        </div>
        <h2 className="text-3xl font-extrabold text-[#363636] mt-5">Congratulations!</h2>
        <p className="text-gray-600 mt-2">You finished Orientation. Great job taking your first step!</p>
        {course && (
          <div className="mt-5 flex items-center gap-2 justify-center rounded-xl bg-[#F6EAF5] px-4 py-3 text-[#4c124a] font-semibold" data-testid="hc-unlocked-course-name">
            <Unlock className="w-4 h-4" /> {course.title} is now unlocked
          </div>
        )}
        <button onClick={go} className="mt-6 w-full h-12 rounded-xl bg-[#922A8C] text-white font-semibold flex items-center justify-center gap-2 hover:bg-[#7a2275]" data-testid="hc-start-unlocked-course">
          {course ? `Start ${course.title}` : 'Go to My Courses'} <ArrowRight className="w-4 h-4" />
        </button>
        <button onClick={onClose} className="mt-3 text-sm text-gray-500 hover:text-[#922A8C]" data-testid="hc-celebration-close">Maybe later</button>
      </div>
    </div>
  );
};

export const ModuleUnlockCelebration = ({ unlock, onClose }) => {
  const navigate = useNavigate();
  const { course, module_number: n } = unlock;
  const start = () => {
    onClose();
    navigate(course.next_lesson_id ? `/helpconnect/courses/${course.id}/lessons/${course.next_lesson_id}` : `/helpconnect/courses/${course.id}`);
  };
  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-4" role="dialog" aria-modal="true" data-testid="hc-module-unlock-celebration">
      <div className="absolute inset-0 bg-[#4c124a]/60 backdrop-blur-sm" onClick={onClose} />
      <div className="relative w-full max-w-md bg-white rounded-3xl p-8 text-center shadow-2xl overflow-hidden hc-pop">
        {DOTS.map((c, i) => (
          <span key={i} className="hc-confetti" style={{ background: c, left: `${6 + i * 8}%`, animationDelay: `${(i % 6) * 0.12}s` }} />
        ))}
        <div className="mx-auto w-20 h-20 rounded-full bg-[#F6EAF5] flex items-center justify-center">
          <Unlock className="w-10 h-10 text-[#922A8C]" />
        </div>
        <h2 className="text-3xl font-extrabold text-[#363636] mt-5">Module Unlocked!</h2>
        <p className="text-gray-600 mt-2">Great work finishing your module. Your next step in Pathways to Employability is ready.</p>
        <div className="mt-5 rounded-xl bg-[#F6EAF5] px-4 py-3 text-[#4c124a] font-semibold" data-testid="hc-unlocked-module-name">
          {n ? `Module ${n}: ` : ''}{n ? course.title.replace(/^M\d+:\s*/, '') : course.title}
        </div>
        <button onClick={start} className="mt-6 w-full h-12 rounded-xl bg-[#922A8C] text-white font-semibold flex items-center justify-center gap-2 hover:bg-[#7a2275]" data-testid="hc-start-unlocked-module">
          Start Module <ArrowRight className="w-4 h-4" />
        </button>
        <button onClick={onClose} className="mt-3 text-sm text-gray-500 hover:text-[#922A8C]" data-testid="hc-module-unlock-close">Maybe later</button>
      </div>
    </div>
  );
};
